import { render, staticRenderFns } from "./AddApp.vue?vue&type=template&id=94e8d84c&scoped=true&"
import script from "./AddApp.vue?vue&type=script&lang=ts&"
export * from "./AddApp.vue?vue&type=script&lang=ts&"
import style0 from "./AddApp.vue?vue&type=style&index=0&id=94e8d84c&lang=scss&scoped=true&"
import style1 from "./AddApp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e8d84c",
  null
  
)

export default component.exports